// A server epoch anchored to a monotonic clock. Changing Date.now() or the
// device timezone after synchronization cannot lengthen/shorten a countdown.
export function createExamClock(monotonicNow = () => performance.now()) {
  let serverEpoch = null;
  let anchor = 0;
  return {
    sync(serverNow) {
      const parsed = Date.parse(serverNow);
      if (!Number.isFinite(parsed)) return;
      serverEpoch = parsed;
      anchor = monotonicNow();
    },
    now() { return serverEpoch === null ? null : serverEpoch + Math.max(0, monotonicNow() - anchor); },
    remaining(deadline) {
      const now = this.now();
      return now === null || deadline == null ? null : Math.max(0, Math.ceil((deadline - now) / 1000));
    },
  };
}

export function answerClasses(questionId, answerId, selected, feedback) {
  const result = feedback[questionId];
  return {
    'answer-option--selected': selected[questionId] === answerId,
    'answer-option--correct': !!result && result.correct_answer_id === answerId,
    'answer-option--incorrect': !!result && !result.is_correct && result.selected_answer_id === answerId,
  };
}

